import { type FC, memo } from 'react';
import { useSettings } from 'store/app/appStore';
import TransWithFallback from '../../../../shared/components/Translations/TransWrapper';
import { useTranslation } from 'react-i18next';

// Tab labels whose snake-case key doesn't prettify into the desired wording on
// i18n miss — mirrors FALLBACK_DISPLAY_NAMES in useGetTranslatedSectionName so
// the tab reads the same as the section title (e.g. "Top Wins", not
// "Top win games").
const FALLBACK_TAB_NAMES: Record<string, string> = {
  TOP_WIN_GAMES: 'Top Wins',
};

const CategoryName: FC<{ categoryKey: string }> = ({ categoryKey }) => {
    const { t } = useTranslation();
    const { restrictions } = useSettings();

  const hasNoJackpotRestriction = restrictions.includes('noJackpot');

  const defaultKey = `tabs.names.${categoryKey.toUpperCase()}_TAB`;
  const noJackpotKey = `tabs.no_jackpot_names.${categoryKey.toUpperCase()}_TAB`;

  const translationKey = hasNoJackpotRestriction && t(noJackpotKey, { defaultValue: '' }) ? noJackpotKey : defaultKey;


  const categoryName = categoryKey.toLowerCase().replace(/_/g, ' ');
  const formattedFallback =
    FALLBACK_TAB_NAMES[categoryKey.toUpperCase()] ??
    categoryName.charAt(0).toUpperCase() + categoryName.slice(1);

  return (
    <TransWithFallback
      i18nKey={translationKey}
      components={{ pnl: <br />, nl: <br /> }}
      customFallbackTranslation={formattedFallback}
    />
  );
};

export default memo(CategoryName);
